// extracted by mini-css-extract-plugin
export var displayNone = "_o2-6";
export var imgContainer = "_o2-2";
export var overflowHidden = "_o2-3";
export var productInfoCardButtonContainer = "_o2-5";
export var productTitleText = "_o2-4";
export var rightArrow = "_o2-1";
export var rightArrowContainer = "_o2-0";